<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
        d="M23.5,5.9V.43l-5,0c-5.55,0-6.8,4.09-6.8,6.69v3.65H8.5v5.63h3.21v16h6.74v-16H22.9l.59-5.63h-5V7.44A1.36,1.36,0,0,1,19.88,5.9Z" />
</svg>